import { Box, Modal, Button, TextField, Typography, IconButton } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { IPlatform } from '../../../../types/spectrum-manager.type'
import { isInvalidNumber } from '../../../../utils/functions'

import styles from './styles.module.scss'

interface IProps {
  open: boolean
  fields: { key: string; column: string; isTag: boolean; isNumeric?: boolean }[]
  platform: IPlatform
  isLightMode: boolean
  onClose: () => void
  handleSave: () => void
  handleChange: (key: string, value: string) => void
}

const PlatformModal = ({ open, fields, platform, isLightMode, onClose, handleSave, handleChange }: IProps) => {
  return (
    <Modal className={styles.modal} open={open} onClose={onClose}>
      <Box className={styles.modalContent}>
        <Box className={styles.content}>
          <Box
            className={styles.header}
            sx={{
              borderBottom: isLightMode ? '1px solid black' : '1px solid white',
            }}
          >
            <Typography className={styles.title} id="title">
              Platform Details
            </Typography>
            <IconButton onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
          <Box className={styles.content}>
            <Box className={styles.fields}>
              {fields.slice(1).map((field) => {
                const value = (platform as any)[field.key]
                const invalid = !!field.isNumeric && isInvalidNumber(value)
                return (
                  <Box className={styles.fieldContainer} key={field.key}>
                    <Typography>{field.column}:</Typography>
                    <TextField
                      value={value}
                      error={invalid}
                      helperText={invalid ? 'Must be a number' : undefined}
                      className={styles.field}
                      size="small"
                      onChange={(evt) => handleChange(field.key, evt.target.value)}
                    />
                  </Box>
                )
              })}
              <Box className={styles.fieldContainer}>
                <Typography></Typography>
                <Button
                  variant="outlined"
                  onClick={handleSave}
                  disabled={fields.some((field) => field.isNumeric && isInvalidNumber((platform as any)[field.key]))}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PlatformModal
